import { useEffect, useRef, useState } from 'react';
import { NJSegmentedControl, NJSegmentedControlButton } from '@engie-group/fluid-design-system-react';

export function PlanSegmentedControl({ label, options, value, onChange }: {
  label: string;
  options: string[];
  value: string;
  onChange: (value: string) => void;
}) {
  const container = useRef<HTMLDivElement>(null);
  const [width, setWidth] = useState(0);
  useEffect(() => {
    if (!container.current) return undefined;
    // Fluid measures its selection indicator on mount/click, not on resize.
    const observer = new ResizeObserver(([entry]) => setWidth(Math.round(entry.contentRect.width)));
    observer.observe(container.current);
    return () => observer.disconnect();
  }, []);

  return (
    <div ref={container} style={{ width: '100%' }}>
      <NJSegmentedControl key={width} label={label} size="sm" value={value} onChange={onChange} style={{ width: '100%' }}>
        {options.map((option) => (
          <NJSegmentedControlButton key={option} value={option} label={option} style={{ flex: '1 1 0', minWidth: 0, justifyContent: 'center' }} />
        ))}
      </NJSegmentedControl>
    </div>
  );
}
